import React, { useContext } from 'react';
import { Button, Modal, message } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import client from '@/lib/feathers';
import { UpdateReservationsContext } from '../TodayReservations';
import type { ContextDefaultReservationType } from '../../types';

interface CancelCarButtonProps {
  reservation: ContextDefaultReservationType;
}

const { confirm } = Modal;
const iconStyle = { fontSize: '50px' };

const CancelCarButton = ({ reservation }: CancelCarButtonProps) => {
  const updateData = useContext(UpdateReservationsContext);

  const cancelCar = () => {
    confirm({
      title: (
        <h3>
          <b>確定刪除叫車預約?</b>
        </h3>
      ),
      icon: <ExclamationCircleOutlined style={iconStyle} />,
      content: '刪除後將無法復原!!',
      okText: '確定',
      okType: 'default',
      cancelText: '取消',
      cancelButtonProps: {
        type: 'primary',
      },
      onOk: async () => {
        await client
          .service('carService')
          .patch(reservation.key, { status: '已取消' });
        message.success('叫車預約已取消！');
        updateData();
      },
    });
  };

  return (
    <Button type="primary" danger onClick={cancelCar}>
      取消
    </Button>
  );
};

export default CancelCarButton;
